<template>
  <!--<el-scrollbar wrapClass="scrollbar-wrapper" class="left-bar">-->
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="true"
     >
      <sidebar-item  :routes="permission_routers"></sidebar-item>
    </el-menu>
  <!--</el-scrollbar>-->
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  $color: #2E4055;
  $hcolor:#409EFF;
  .el-menu--popup-right-start{
    margin: 0px;
    padding: 0px;
    background: $color;
  }
  .el-menu--popup-right-start,.left-bar-item{
    background: $color;
    .el-submenu.is-active,
    .el-menu-item:focus,
    .el-menu-item:hover,
    .el-menu-item.is-active,
    .el-submenu__title:hover{
      background: $hcolor;
    }
    .svg-icon{
      width: 24px !important;
      height: 24px !important;
      vertical-align: middle;
      margin-right: 4px !important;
    }
  }
  .left-bar-item{
    .el-menu-item:focus,
    .el-submenu.is-active,
    .el-menu-item.is-active{
      position: relative;
      &:after{
         position: absolute;
         content: '';
         width:4px;
         height:4px;
         border-radius:50%;
         background: #ffffff;
         left: 4px;
         top: 50%;
       }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue